enum EntityType {
    /**
     * Event
     */
    EventReservation,

    /**
     * Flight
     */
    FlightReservation,

    /**
     * Food
     */
    FoodReservation,

    /**
     * Invoice
     */
    Invoice,

    /**
     * Hotel
     */
    LodgingReservation,

    /**
     * Parcel Delivery
     */
    ParcelDelivery,

    /**
     * Rental car
     */
    RentalCarReservation,

    /**
     * Service reservation
     */
    ServiceReservation,

    /**
     * Unsuccessful flight reservation
     */
    UnsuccessfulFlightReservation,

    /**
     * Unsuccessful hotel reservation
     */
    UnsuccessfulLodgingReservation,

    /**
     * Unsuccessful rental car
     */
    UnsuccessfulRentalCarReservation,
}

export default EntityType;
